import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom"; 
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function LatestInnerBlog() {
  const [LatestInnerBlog, setLatestInnerBlog] = useState([]);
  const location = useLocation();

  useEffect(() => {
    document.activeElement.blur();
  }, [location]);

  useEffect(() => {
    const fetchLatestInnerBlog = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/blogs/latest-three-blogs`
        );
        if (!response.ok) {
          throw new Error("Blog not found");
        }
        const data = await response.json();
        setLatestInnerBlog(data);
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
    };

    fetchLatestInnerBlog();
  }, []);

  const extractFirstSentence = (htmlContent) => {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(htmlContent, "text/html");

    // Get the first paragraph
    const firstParagraph = parsedDocument.querySelector("p");

    if (firstParagraph) {
      let textContent = firstParagraph.textContent.trim();
      const sentences = textContent.match(/[^.!?]+[.!?]/g);

      // Return the first sentence if available
      if (sentences && sentences.length > 1) {
        return sentences[0].trim();
      }
    }

    return "";
  };

  return (
    <section className="media-list-sec blog-inner-list-sec">
      <Container fluid>
        <Row className="flex-center text-center mb-3">
          <Col md={12}>
            <div className="home-community-head">
              <h2 className="common-head greyColor" data-aos="fade-up">
                Related Blogs
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row className="flex-center">
          {LatestInnerBlog.map((lastestblog) => (
            <Col md={4} key={lastestblog.id}>
              <div className="media-list-card" data-aos="fade-up">
                <div className="media-list-img">
                  <img
                    src={`${apiUrl.apiUrl}/${lastestblog.card_image}`}
                    className="img-fluid"
                    alt={lastestblog.blog_title}
                  />
                </div>
                <div className="media-list-content">
                  <h2 className="media-list-heading blog-list-heading">
                    {lastestblog.blog_title}
                  </h2>
                  <p className="media-list-para blog-list-para">
                    {extractFirstSentence(lastestblog.description)}
                  </p>

                  <div className="media-list-button-div">
                    <Link
                      to={`/blog/${lastestblog.slug}`}
                      className="marquis-roundededge-colored-button"
                      onClick={(e) => e.target.blur()}
                    >
                      Read More
                    </Link>
                    <p className="media-list-para goldenColor">
                      Date: {lastestblog.place} {lastestblog.posting_date}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default LatestInnerBlog;
